// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Summary_summary__H7IBb .Summary_avatar__pHlpU {
  margin-bottom: 20px;
}
.Summary_summary__H7IBb .Summary_avatar__pHlpU img {
  width: 100px;
  height: 100px;
  border-radius: 10px;
  object-fit: cover;
}
.Summary_summary__H7IBb .Summary_information-form__JfiWQ .Summary_update-button__P3zQT {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 30px;
}`, "",{"version":3,"sources":["webpack://./src/Admin/Pages/PersonalProfile/Components/Summary/Summary.module.scss"],"names":[],"mappings":"AACE;EACE,mBAAA;AAAJ;AACI;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;AACN;AAGI;EACE,WAAA;EACA,aAAA;EACA,yBAAA;EACA,aAAA;AADN","sourcesContent":[".summary {\n  .avatar {\n    margin-bottom: 20px;\n    img {\n      width: 100px;\n      height: 100px;\n      border-radius: 10px;\n      object-fit: cover;\n    }\n  }\n  .information-form {\n    .update-button {\n      width: 100%;\n      display: flex;\n      justify-content: flex-end;\n      padding: 30px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"summary": `Summary_summary__H7IBb`,
	"avatar": `Summary_avatar__pHlpU`,
	"information-form": `Summary_information-form__JfiWQ`,
	"update-button": `Summary_update-button__P3zQT`
};
export default ___CSS_LOADER_EXPORT___;
